import '../css/MessageNotificationIcon.css';

const MessageNotificationIcon = ({ isVisible }: { isVisible?: boolean }) => {
  if (isVisible) {
      return (
        <span className="glyphicon glyphicon-bell new-message"></span>
      );
  }
  return null;
};

export default MessageNotificationIcon;